import { getAppVersion } from './platform';

const style = 'background: #0158a3; color: #fff; font-weight: 700; border-radius: 5px; padding-inline: 5px; font-size: 1.2em;';

export const logSkytta = (s: string, obj?: any) => {
  // biome-ignore lint/suspicious/noConsole: Logging SKYTTA app things for informational purposes
  console.info('%cSKYTTA', style, s, obj !== undefined ? obj : '');
};

/**
 * Use to log app version at startup
 */
export const logSkyttaAppVersion = () => {
  const appVersion = getAppVersion();
  logSkytta(`App version: ${appVersion}`);
};
